import type { ExplorationSelection } from '../../types/exploration';

/**
 * When canvas out calls `navigate(-1)` but the URL search string does not change
 * (duplicate same-URL history entry), avoid `DRILL_UP` visit-pop while a volume
 * is selected — that clears selection and can replace to a bare instance mid
 * volume undo chain. Clear volume selection instead (keeps drillPath; drops a
 * same-location volume visit frame).
 */
export type CanvasOutSameUrlFallback = 'clear-selection' | 'drill-up';

export function planCanvasOutSameUrlFallback(
  selectedNode: ExplorationSelection
): CanvasOutSameUrlFallback {
  if (selectedNode?.kind === 'volume') return 'clear-selection';
  return 'drill-up';
}
